import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=61634304&"
import script from "./Page404.vue?vue&type=script&lang=js&"
export * from "./Page404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61634304')) {
      api.createRecord('61634304', component.options)
    } else {
      api.reload('61634304', component.options)
    }
    module.hot.accept("./Page404.vue?vue&type=template&id=61634304&", function () {
      api.rerender('61634304', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/404/Page404.vue"
export default component.exports